import { GrowthBook } from "@growthbook/growthbook";
import { BrowserCookieStickyBucketService } from "@growthbook/growthbook";
import Cookies from 'js-cookie';
import * as features from "@/scripts/store/features";

const growth_book = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-bFMPGDFC9sMwhjsE",
  enableDevMode: process.env.NODE_ENV === "development",
  subscribeToChanges: true,
  stickyBucketService: new BrowserCookieStickyBucketService({
    jsCookie: Cookies,
  }),
  trackingCallback: (experiment, result) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "viewed_experiment",
      experimentId: experiment.key,
      variationId: result.key
    });
  }
});
window.gb = growth_book; // Expose for debugging
window.growth_book = growth_book; // Expose for debugging

//===========================
// Collect user attributes
//===========================

//should match tailwind.config.js
const screens = {
  'sm': '700px',
  'md': '1000px',
  'lg': '1150px',
  'xl': '1400px',
  '2xl': '1600px',
}

const screenSize = Object.keys(screens).reverse().find((key) => {
  return window.innerWidth > parseInt(screens[key]);
});

const waitForHeapId = function(){
  return new Promise((resolve, reject) => {
    const heapId = window.heap.getUserId();
    if(heapId){
      setGbAttributes(heapId);
      resolve();
    }else{
      window.addEventListener("heapReady", function (event) {
        setGbAttributes(window.heap.getUserId());
        resolve();
      });
    }
  });
}

const setGbAttributes = function(id){
  growth_book.setAttributes({
    id: id,
    email: window?.userAttributes?.email,
    customerId: window?.userAttributes?.customerId,
    totalSpent: window?.userAttributes?.totalSpent,
    ordersCount: window?.userAttributes?.ordersCount,
    tags: window?.userAttributes?.tags,
    country: Shopify.country,
    locale: Shopify?.locale,
    currency: Shopify?.currency?.active,
    url: window.location.href,
    userAgent: navigator.userAgent,
    screenWidth: window.innerWidth,
    screenSize: screenSize,
    themeId: Shopify.theme.id,
    themeName: Shopify.theme.name,
    themeRole: Shopify.theme.role,
    params: paramsToObject(new URL(document.location).searchParams)
  });
}

//===========================
// setup growthbook
//===========================

function paramsToObject(entries) {
  const result = {}
  for(const [key, value] of entries) { // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
}

export const setupGrowthbook = async function(){

    await waitForHeapId();

    // Wait for features to be available
    await growth_book.init({ timeout: 1000 }); 

    for(const key in features){
      const feature = features[key];
      const value = growth_book.getFeatureValue(feature.key);
      if(typeof value != "undefined"){
          feature.init(value);
      }
    }

    growth_book.setRenderer(() => {
      for(const key in features){
          const feature = features[key];
          const value = growth_book.getFeatureValue(feature.key);
          if(typeof value != "undefined"){
              feature.init(value);
          }
      }
    });

    growth_book.setForcedVariations({
      "remark": 1
    });

    if(window.localStorage.getItem("isInRemarkABControlGroup")){
      growth_book.setForcedVariations({
        "remark": window.localStorage.getItem("isInRemarkABControlGroup") == "true" ? 0 : 1
      });
      window.dataLayer.push({
        event: "viewed_experiment",
        experimentId: "remark",
        variationId: window.localStorage.getItem("isInRemarkABControlGroup") == "true" ? 0 : 1
      });
    }else{
      window.addEventListener("remark:sdk-initialized", () => { 
        growth_book.setForcedVariations({
          "remark": window.localStorage.getItem("isInRemarkABControlGroup") == "true" ? 0 : 1
        });
        window.dataLayer.push({
          event: "viewed_experiment",
          experimentId: "remark",
          variationId: window.localStorage.getItem("isInRemarkABControlGroup") == "true" ? 0 : 1
        });
      });
    }

    //publish event that growthbook is ready
    window.dispatchEvent(new Event('growthbookReady'));
}